export default "__VITE_ASSET__CXfZTrO___"